import {red} from '@mui/material/colors';
import {createTheme} from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
    palette   : {
        primary  : {
            main: '#1C3AA4',
        },
        secondary: {
            main        : '#969692',
            contrastText: '#FFFFFF',
        },
        error    : {
            main: red.A400,
        },
        action   : {
            disabledBackground: 'rgba(0,0,0,.2)',
            disabled          : 'rgba(138,138,138,.9)',
        },
    },
    shape     : {
        borderRadius: 14,
    },
    typography: {
        button: {
            textTransform: 'none',
        },
    },
    components: {
        MuiButton     : {
            defaultProps: {
                disableElevation: true,
                size            : 'large',
                sx              : {
                    height  : 56,
                    fontSize: 20,
                },
            },
        },
        MuiTextField  : {
            defaultProps: {
                variant  : 'filled',
                fullWidth: true,
            },
        },
        MuiFilledInput: {
            defaultProps: {
                disableUnderline: true,
                fullWidth       : true,
            },
        },
    },
});

export default theme;
